{
  "collect": "검체 채취",
  "track": "검체 추적",
  "accession": "접수 번호",
  "barcode": "바코드",
  "status": {
    "ordered": "처방됨",
    "collected": "채취됨",
    "inTransit": "이송 중",
    "received": "접수됨",
    "processing": "검사 중",
    "resulted": "결과 보고됨",
    "rejected": "Rejected",
    "in_transit": "이송 중"
  },
  "title": "Specimens",
  "loading": "Loading specimens…",
  "errorState": "Could not load specimens.",
  "emptyState": "No specimens for this patient.",
  "noRejectionReason": "Rejected — no reason recorded",
  "columns": {
    "accession": "Accession",
    "type": "Type",
    "status": "Status",
    "collected": "Collected",
    "received": "Received",
    "location": "Location"
  }
}
